export class HawkRouteConfig<T> {
    constructor(pathname: string, toNavigationPath?: (params?: T) => string) {
        this.pathname = pathname.replace("/app", "");
        this.toNavigationPath = toNavigationPath ?? (() => this.pathname);
    }

    pathname: string;
    toNavigationPath: (params?: T) => string;
}

export const hawkRouteConfig = {
    base: new HawkRouteConfig("/Admin/Hawk"),
    error: new HawkRouteConfig("/Admin/Hawk/Error"),
    lineItem: new HawkRouteConfig<{ lineItemId: string }>(
        "/Admin/Hawk/LineItem/:lineItemId",
        (params) => `/Admin/Hawk/LineItem/${params?.lineItemId}`,
    ),
    products: new HawkRouteConfig("/Admin/Hawk/Products"),
    queue: new HawkRouteConfig<{ queueId: string }>(
        "/Admin/Hawk/Queue/:queueId",
        (params) => `/Admin/Hawk/Queue/${params?.queueId}`,
    ),
    queueLineItem: new HawkRouteConfig<{ queueId: string; lineItemId: string }>(
        "/Admin/Hawk/Queue/:queueId/LineItem/:lineItemId",
        (params) => `/Admin/Hawk/Queue/${params?.queueId}/LineItem/${params?.lineItemId}`,
    ),
    receipt: new HawkRouteConfig<{ queueId: string; lineItemId: string }>(
        "/Admin/Hawk/Queue/:queueId/LineItem/:lineItemId/Receipt",
        (params) => `/Admin/Hawk/Queue/${params?.queueId}/LineItem/${params?.lineItemId}/Receipt`,
    ),
    reviewHistory: new HawkRouteConfig("/Admin/Hawk/ReviewHistory"),
};
